import { RESET_FORM } from '../actionTypes';
import { templatesActions } from '../reducer';

export default () => templatesActions[RESET_FORM]();
